

import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './../css/Footer.css'
import { fetchCategories } from './../contexts/categoryService'; // Adjust the import path

export default function Footer() {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
      const getCategories = async () => {
        try {
          const fetchedCategories = await fetchCategories();
          setCategories(fetchedCategories);
        } catch (error) {
          console.error("Error fetching categories: ", error);
        }
      };
  
      getCategories();
    }, []);
  return (
    <>
          <footer>
        <div class="container" style={{paddingTop: "10vh"}}>
            <div class="row">
                <div class="col-md-4">
                    <h4 className='white-bordered-bottom unbounded'>
                        Company
                    </h4>
                    <div class="footer-links">
                        <Link to="/about">
                            About Us
                        </Link>
                        <Link to="/terms">
                            Term and Conditions
                        </Link>
                        <Link to="/privacy-policy">
                            Privacy Policy
                        </Link>
                        <Link to="/refund-policy">
                            Refund Policy
                        </Link>
                    </div>
                </div>
                <div class="col-md-4">
                    <h4 className='white-bordered-bottom unbounded'>
                        Category
                    </h4>
                    <div class="footer-links">
                        {categories.map(category => (
                            <Link to={`/products/${encodeURIComponent(category.name)}`}key={category.id}>
                                {category.name}
                            </Link>
                        ))}
                    </div>
                </div>
                <div class="col-md-4">
                    <h4 className='white-bordered-bottom unbounded'>
                        Socials
                    </h4>
                    <p>
                        Hit us up if you have any questions!
                    </p>

                    <div className="d-flex flex-column">
              <a href="tel:+2349071838043" style={{ color: "white" }}>
                Phone NGN: +234 9071838043
              </a>
              <a
                href="mailto:info@vlmstnvsbl.com"
                style={{ color: "white" }}
              >
                Email: info@vlmstnvsbl.com
              </a>
            </div>
            <br />
    
            <div className="social">
              
              <a href="https://www.instagram.com/almostinvisibleispeak/profilecard/?igsh=MWtkbG9ocWdmMmJ3cg==" target='_blank'>
                <svg
                  stroke="currentColor"
                  fill="white"
                  strokeWidth={0}
                  viewBox="0 0 1024 1024"
                  height="1.6em"
                  width="1.6em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z" />
                </svg>
              </a>

              <a href="https://x.com/vlmstnvsbl?s=21&t=X0vqH7bGqWrInzVTaFWvbA" target='_blank'>
                <svg xmlns="http://www.w3.org/2000/svg" fill="white" shape-rendering="geometricPrecision" height="1.5em" width="1.5em" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 462.799"><path fill-rule="nonzero" d="M403.229 0h78.506L310.219 196.04 512 462.799H354.002L230.261 301.007 88.669 462.799h-78.56l183.455-209.683L0 0h161.999l111.856 147.88L403.229 0zm-27.556 415.805h43.505L138.363 44.527h-46.68l283.99 371.278z"/></svg>
              </a>
             
              <a href="https://wa.me/+2348157081943" target='_blank'>
              <svg stroke="currentColor" fill="white" stroke-width="0" viewBox="0 0 448 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"></path></svg>              </a>
             </div>
                    
                </div>
                {/** 
                <div class="col-md-4">
                    <h4 className='white-bordered-bottom unbounded'>
                        Newsletter
                    </h4>
                    <p>
                        Subscribe to our newsletter to get latest update on our products
                    </p>
                    <form action="#" class="newsletter-form">
                        <input type="email" class="input" placeholder="Enter your email address" />
                        <br />
                        <button type="submit" class="white-button">
                            Subscribe Now
                        </button>
                    </form>
                </div>*/}
            </div>
        </div>
        <br />
        <div class="intervention">

        </div>
        <br />
        <div class="col-12 copyright d-flex justify-content-center align-content-center">
            <svg style={{marginTop: "1vh"}} stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 1024 1024" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z"></path></svg>
            &nbsp;&nbsp;
            <p>
                Copyrights {new Date().getFullYear()} ALMOSTINVISIBLE
            </p>
        </div>
    </footer>
    </>
  )
}
